import "./skills.css";

const Skills = () => (
  <div className="skills-container mt-5" id="MySkills">
    <h1 className="skills">SKILLS</h1>
    <ul className="skills-list">
      <li>
        <img src="/images/html (2).png" alt="html logo" width={100} />
      </li>
      <li>
        <img src="/images/css3 (1).png" alt="css logo" width={100} />
      </li>
      <li>
        <img src="/images/pngwing.com.png" alt="js logo" width={100} />
      </li>
      <li>
        <img src="/images/bootstrap.png" alt="bs logo" width={100} />
      </li>
      {/* <li>
        <img src="/images/sass.png" alt="sass logo" width={100} />
      </li> */}
      <li>
        <img src="/images/react.png" alt="react logo" width={100} />
      </li>
      <li>
        <img src="/images/flutter.png" alt="flutter logo" width={100} />
      </li>
      <li>
        <img src="/images/python.png" alt="py logo" width={100} />
      </li>
      <li>
        <img src="/images/dart.png" alt="dart logo" width={100} />
      </li>
      <li>
        <img src="/images/node-js.png" alt="node logo" width={100} />
      </li>
      <li>
        <img src="/images/django.png" alt="django logo" width={100} />
      </li>
      <li>
        <img src="/images/FastAPI.png" alt="Fastapi logo" width={100} />
      </li>
      {/* <li>
        <img src="/images/pngwing.com (1).png" alt="ex logo" width={100} />
      </li> */}
      <li>
        <img src="/images/mysql.png" alt="sql logo" width={100} />
      </li>
    </ul>
  </div>
);
export default Skills;
